<template lang="pug">
w-btn-icon.w-btn-user(
  v-bind='{ icon, size }'
  :hover='!!loggedIn'
  :hoverAction='accountAction'
  @click.prevent='accountAction'
)
  transition( name='fade-fast' mode='out-in' )
    i-account( v-if='loggedIn' key='user' )
    span.sign-in( v-else key='anon' ) sign in
</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import he from 'he'
import IAccount from 'icons/Account'
import WBtnIcon, { mixin } from '@/widgets/w-btn-icon'
import { User } from '@/mixins'

export default {
  name: 'UserButtonWidget',
  mixins: [ User, mixin ],
  components: { WBtnIcon, IAccount },
  props: {},
  data() {
    return {
      wait: null,
      allowHide: true,
      isShown: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'openModal', 'openSidebar' ]),
    accountAction() {
      if ( this.loggedIn ) {
        this.openSidebar({ name: 's-user' })
      } else {
        this.openModal({ name: 'm-auth' })
      }
    }
  },
  computed: {
    ...mapGetters([ 'loggedIn' ]),
    isLoginRoute() {
      return this.$route.name === 'login'
    }
  }
}
</script>

<style lang="scss">
.w-btn-icon.w-btn-user {
  .sign-in {
    font-size: var(--s-base);
  }
}
</style>
